// import { Box, Typography } from "@mui/material";
// import { Link as RouterLink } from "react-router-dom";
// import React from "react";

// function SiteLogo({ color }) {
//   const logoColor = color || "inherit";
//   return (
//     <Box>
//       <Typography
//         variant="h5"
//         component={RouterLink}
//         to="/"
//         sx={{ textDecoration: "none", color: "inherit" }}
//       >
//         <Box
//           component="span"
//           style={{
//             color: "#f6521a",
//             fontSize: "22px",
//             display: "inline-block",
//             transform: "rotate(-15deg)",
//             marginRight: "4px",
//           }}
//         >
//           T
//         </Box>
//         <Box
//           component="span"
//           style={{
//             verticalAlign: "middle",
//             color: logoColor,
//           }}
//         >
//           POS
//         </Box>
//       </Typography>
//     </Box>
//   );
// }

// export default SiteLogo;


import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import React from "react";

function SiteLogo({ color, showTagline = false }) {
  const logoColor = color || "inherit";

  return (
    <Box>
      {/* MAIN LOGO */}
      <Typography
        variant="h5"
        component={RouterLink}
        to="/"
        sx={{ textDecoration: "none", color: "inherit", display: "inline-block" }}
      >
        <Box
          component="span"
          sx={{
            color: "#f6521a",
            fontSize: "22px",
            display: "inline-block",
            transform: "rotate(-15deg)",
            mr: "4px",
          }}
        >
          T
        </Box>

        <Box
          component="span"
          sx={{
            verticalAlign: "middle",
            color: logoColor,
          }}
        >
          POS
        </Box>
      </Typography>

      {/* CONDITIONAL TAGLINE */}
      {showTagline && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "text.secondary",
            fontSize: "0.78rem",
          }}
        >
          POS by TrueMenu
        </Typography>
      )}
    </Box>
  );
}

export default SiteLogo;

